import { request } from '@/utils/request'

export function classMap(params) {
  return request({
    url: '/api/map/class',
    method: 'get',
    params
  })
}

export function classList(params) {
  return request({
    url: '/api/class/list',
    method: 'get',
    params
  })
}

export function classSave(data) {
  return request({
    url: '/api/class/save',
    method: 'post',
    data
  })
}

export function classDel(data) {
  return request({
    url: '/api/class/delete',
    method: 'post',
    data
  })
}

// 去上课
export function goClass(data) {
  return request({
    url: '/api/lesson/begin',
    method: 'post',
    data
  })
}

export function studentList(params) {
  return request({
    url: '/api/student/list',
    method: 'get',
    params
  })
}

export function studentSave(data) {
  return request({
    url: '/api/student/save',
    method: 'post',
    data
  })
}

export function studentDel(data) {
  return request({
    url: '/api/student/delete',
    method: 'post',
    data
  })
}

export function studentImport(data) {
  return request({
    url: '/api/student/import',
    method: 'post',
    data
  })
}

export function studentExport(params) {
  return request({
    url: '/api/student/export',
    method: 'get',
    params
  })
}

export function resourceList(data) {
  return request({
    url: '/api/res/list',
    method: 'post',
    data
  })
}

// 选课
export function selectCourse(data) {
  return request({
    url: '/api/student/select-course/join',
    method: 'post',
    data
  })
}

// 取消选课
export function cancelSelectCourse(data) {
  return request({
    url: '/api/student/select-course/cancel',
    method: 'post',
    data
  })
}

// 获取课件列表
export function creatorLessonList(params) {
  return request({
    url: '/api/creator/lesson/list',
    method: 'get',
    params
  })
}

// 删除课件
export function creatorLessonDel(data) {
  return request({
    url: '/api/creator/lesson/delete',
    method: 'post',
    data
  })
}

// 获取专业筛选项
export function professionMap(params) {
  return request({
    url: '/api/map/profession',
    method: 'get',
    params
  })
}

// // 获取播放器筛选项
// export function playerMap (params) {
//   return request({
//     url: '/api/map/player',
//     method: 'get',
//     params
//   })
// }

// 获取资源详情
export function resourceDetail(params) {
  return request({
    url: '/api/res/detail',
    method: 'get',
    params
  })
}

// 获取备课列表数据
export function prepareLessonList(params) {
  return request({
    url: '/api/prepare_lesson/list',
    method: 'get',
    params
  })
}

// 保存备课数据
export function prepareLessonSave(data) {
  return request({
    url: '/api/prepare_lesson/save',
    method: 'post',
    data
  })
}

// 获取备课详情
export function prepareLessonDetail(params) {
  return request({
    url: '/api/prepare_lesson/detail',
    method: 'get',
    params
  })
}

// 复制当前备课数据
export function prepareLessonCopy(data) {
  return request({
    url: '/api/prepare_lesson/copy',
    method: 'post',
    data
  })
}

// 重命名备课名称
export function prepareLessonRename(data) {
  return request({
    url: '/api/prepare_lesson/rename',
    method: 'post',
    data
  })
}

// 设置备课置顶
export function prepareLessonSetTop(data) {
  return request({
    url: '/api/prepare_lesson/set_top_status',
    method: 'post',
    data
  })
}

// 删除备课数据
export function prepareLessonDelete(data) {
  return request({
    url: '/api/prepare_lesson/delete',
    method: 'post',
    data
  })
}

// 结束备课状态
export function prepareLessonStop(data) {
  return request({
    url: '/api/prepare_lesson/set_top_status',
    method: 'post',
    data
  })
}

// 获取课程列表
export function lessonList(params) {
  return request({
    url: '/api/teacher/lesson/list',
    method: 'get',
    params
  })
}

// 删除课程
export function lessonDel(data) {
  return request({
    url: '/api/lesson/delete',
    method: 'post',
    data
  })
}

// 课程监控
export function lessonMonitor(params) {
  return request({
    url: '/api/lesson/monitor',
    method: 'get',
    params
  })
}

// 保存课程
export function lessonSave(data) {
  return request({
    url: '/api/lesson/save',
    method: 'post',
    data
  })
}

// 获取课程详情
export function lessonDetail(params) {
  return request({
    url: '/api/lesson/detail',
    method: 'get',
    params
  })
}

// 结束课程
export function lessonClose(data) {
  return request({
    url: '/api/lesson/close',
    method: 'post',
    data
  })
}

// 获取课堂报告数据
export function lessonData(params) {
  return request({
    url: '/api/lesson/data',
    method: 'get',
    params
  })
}

// 导出课堂报告数据
export function lessonDataExport(params) {
  return request({
    url: '/api/lesson/data_export',
    method: 'get',
    params
  })
}

// 资源类型筛选
export function resTypeMap(params) {
  return request({
    url: '/api/map/res_type',
    method: 'get',
    params
  })
}

// 获取XR下载地址
export function getClientUrl() {
  return request({
    url: '/api/xr/client-url',
    method: 'get'
  })
}

// 学历列表
export function getEducationType(params) {
  return request({
    url: '/api/map/education_type',
    method: 'get',
    params
  })
}
// 职称列表
export function getRankType(params) {
  return request({
    url: '/api/map/rank_type',
    method: 'get',
    params
  })
} // 专业列表
export function getAdminOrgList(params) {
  return request({
    url: '/api/admin/school/org/list',
    method: 'get',
    params
  })
}
// 资源批量上传
export function batchUpload(data) {
  return request({
    url: '/api/resource/save',
    method: 'post',
    data
  })
}
// 个人资源
export function getPersonResList(params) {
  return request({
    url: '/api/resource/list',
    method: 'get',
    params
  })
}
// 个人资源详情
export function getPersonResDetails(params) {
  return request({
    url: '/api/resource/detail',
    method: 'get',
    params
  })
}
// 个人资源共享
export function common(data) {
  return request({
    url: '/api/resource/share',
    method: 'post',
    data
  })
}
// 个人资源分享
export function share(data) {
  return request({
    url: '/api/resource/self/share',
    method: 'post',
    data
  })
}
// 取消共享
export function unCommon(data) {
  return request({
    url: '/api/resource/cancel_share',
    method: 'post',
    data
  })
}
// 取消分享
export function unShare(data) {
  return request({
    url: '/api/resource/self/cancel_share',
    method: 'post',
    data
  })
}
// 个人资源删除
export function deleteResource(data) {
  return request({
    url: '/api/resource/delete',
    method: 'post',
    data
  })
}
// 学校下所有老师、学生
export function getSchoolMembers(params) {
  return request({
    url: '/api/school/members',
    method: 'get',
    params
  })
}
// 学校下所有老师、学生(学生)
export function getClasslMembers(params) {
  return request({
    url: '/api/class/members',
    method: 'get',
    params
  })
}
// 资源点赞
export function resourceLike(data) {
  return request({
    url: '/api/resource/like',
    method: 'post',
    data
  })
}
// 资源取消点赞
export function resourceUnlike(data) {
  return request({
    url: '/api/resource/unlike',
    method: 'post',
    data
  })
}
// 资源收藏
export function resourceCollect(data) {
  return request({
    url: '/api/resource/collect',
    method: 'post',
    data
  })
}
// 资源取消收藏
export function resourceUncollect(data) {
  return request({
    url: '/api/resource/uncollect',
    method: 'post',
    data
  })
}
// 点赞收藏列表
export function getFavoritesResource(params) {
  return request({
    url: '/api/interactions/resource/list',
    method: 'get',
    params
  })
}

// 获取题目
export function getTopicByType(params) {
  return request({
    url: '/t-examine-api/subject/getListByType',
    method: 'get',
    params
  })
}

// 共享课程编辑
export function shareLessonSave(data) {
  return request({
    url: '/api/portal-lesson-apply/save',
    method: 'post',
    data
  })
}

// 获取所有老师
export function getAllTeacher(params) {
  return request({
    url: '/api/teacher/list/all',
    method: 'get',
    params
  })
}

// 课程提交审核
export function lessonSubmitAudit(data) {
  return request({
    url: '/api/portal-lesson-apply/submit',
    method: 'post',
    data
  })
}

// 保存导学
export function saveGuidance(data) {
  return request({
    url: '/api/lesson-guidance/save',
    method: 'post',
    data
  })
}

// 导学详情
export function guidanceDetail(params) {
  return request({
    url: '/api/lesson-guidance/detail',
    method: 'get',
    params
  })
}

// 删除导学
export function guidanceDel(data) {
  return request({
    url: '/api/lesson-guidance/delete',
    method: 'post',
    data
  })
}

// 章节列表
export function chapterList(params) {
  return request({
    url: '/api/lesson-chapter/list',
    method: 'get',
    params
  })
}

// 导学列表
export function guidanceList(params) {
  return request({
    url: '/api/lesson-guidance/list',
    method: 'get',
    params
  })
}

// 导学报告详情
export function lessonGuidanceDetail(data) {
  return request({
    url: '/api/lesson-guidance/report',
    method: 'post',
    data
  })
}

// 导出导学报告
export function exportLessonGuidance(data) {
  return request({
    url: '/api/lesson-guidance/export',
    method: 'post',
    data
  })
}

// 设置资源权重
export function updateResourceWeight(data) {
  return request({
    url: '/api/resource/set-order',
    method: 'post',
    data
  })
}

// 取消课程收藏
export function cancelCollect(data) {
  return request({
    url: '/api/portal/lesson/un-collect',
    method: 'post',
    data
  })
}

// 取消课程点赞
export function cancelLike(data) {
  return request({
    url: '/api/portal/lesson/unlike',
    method: 'post',
    data
  })
}

// 行业列表
export function industryList(params) {
  return request({
    url: '/api/industry/list',
    method: 'get',
    params
  })
}

// 地区列表
export function regionList(params) {
  return request({
    url: '/api/area/list',
    method: 'get',
    params
  })
}

// 星级列表
export function starList(params) {
  return request({
    url: '/api/map/star_level',
    method: 'get',
    params
  })
}

// 设备列表
export function machineList(params) {
  return request({
    url: '/api/map/machine/list',
    method: 'get',
    params
  })
}
